import React, { useEffect } from "react"
import PartDetailsDataGrid from "./PartDetailsDataGrid"
import DetailsFooter from "./detailsFooter"
import PropTypes from "prop-types"

import { useDecimalFormatter } from "hooks/useDecimalFormatter"
import { TOTAL_DECOMPOSITIONS } from "constants/decimals"
import {
  getLegacyNormalizedQuantity,
  resolveFactorAndWaste,
} from "./partDetails.utils"

const PartDetails = ({
  details,
  setDetails,
  partidaState,
  bancoDePrecios,
  showDynamicElementButton = false,
  isTender,
}) => {
  const { roundToDecimals } = useDecimalFormatter()

  useEffect(() => {
    let acc = 0
    let accWithoutReduction = 0
    let newDetails = []
    let needsUpdate = false

    details.forEach(detail => {
      const originalQty = Number(detail.quantity) || 0
      const normalizedQty = getLegacyNormalizedQuantity(detail)

      // Usar priceReduced si existe, si no, usar price
      const precioReducido =
        detail.priceReduced !== undefined && detail.priceReduced !== null
          ? Number(detail.priceReduced)
          : Number(detail.price) || 0
      const precioBase = Number(detail.price) || 0

      const { factorValue, wasteValue } = resolveFactorAndWaste({
        factor: detail.factor,
        waste: detail.waste,
        quantity: normalizedQty,
      })

      if (detail.unity !== "%") {
        acc += precioReducido * normalizedQty
        accWithoutReduction += precioBase * normalizedQty

        if (normalizedQty !== originalQty) {
          needsUpdate = true
          newDetails.push({
            ...detail,
            quantity: normalizedQty,
            factor: factorValue,
            waste: wasteValue,
            code: detail.code ?? "",
          })
        } else {
          // Verificar si el factor necesita actualizarse (solo si no tenía un valor válido antes)
          const currentFactor = detail.factor
          const needsFactorUpdate =
            currentFactor === undefined ||
            currentFactor === null ||
            isNaN(Number(currentFactor))

          if (needsFactorUpdate) {
            needsUpdate = true
          }
          newDetails.push({
            ...detail,
            factor: needsFactorUpdate ? factorValue : currentFactor,
            waste: needsFactorUpdate ? wasteValue : detail.waste,
            code: detail.code ?? "",
          })
        }
      } else {
        const computedPrice = acc
        const shouldUpdatePrice = Number(detail.price) !== computedPrice
        const shouldUpdateQty = normalizedQty !== originalQty

        if (shouldUpdatePrice || shouldUpdateQty) {
          needsUpdate = true
        }
        newDetails.push({
          ...detail,
          price: acc,
          total: roundToDecimals(
            acc * (detail.quantity + (detail.waste || 0)),
            TOTAL_DECOMPOSITIONS,
          ),
          factor: factorValue,
          waste: wasteValue,
          code: detail.code ?? "",
        })
      }
    })

    console.log("Total con reducción:", acc)
    console.log(
      "Total sin reducción (totalWithoutReduction):",
      accWithoutReduction,
    )

    if (needsUpdate) {
      setDetails(newDetails)
    }
  }, [details, setDetails])

  const addEmptyDetail = () => {
    const newDetail = {
      type: "",
      description: "",
      price: 0,
      quantity: 0,
      waste: 0,
      factor: 1,
      total: 0,
      unity: "pa",
      code: "",
    }
    setDetails(prevArray => [...prevArray, newDetail])
  }

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          overflowY: "auto",
          maxHeight: "calc(100vh - 350px)",
          height: "calc(100% - 114px )",
          padding: "15px",
        }}
      >
        <PartDetailsDataGrid
          details={details}
          setDetails={setDetails}
          bancoDePrecios={bancoDePrecios}
          partidaState={partidaState}
          showDynamicElementButton={showDynamicElementButton}
          onAddEmptyDetail={addEmptyDetail}
          isTender={isTender}
        />
      </div>

      <DetailsFooter partidaState={partidaState} details={details} />
    </div>
  )
}

PartDetails.propTypes = {
  details: PropTypes.array.isRequired,
  setDetails: PropTypes.func.isRequired,
  partidaState: PropTypes.object.isRequired,
  bancoDePrecios: PropTypes.string,
  showDynamicElementButton: PropTypes.bool,
  isTender: PropTypes.bool,
}

export default PartDetails
